import { useState, useEffect } from 'react';

export function getCookieValue(name) {
    const match = document.cookie.split('; ').find(c => c.startsWith(name + '='));
    return match ? match.split('=')[1] : null;
}

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
}

function CookieConsent() {
    const seoSettings = window.__WEBSITE__?.seoSettings || {};
    const showCookieConsent = seoSettings.showCookieConsent;

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!showCookieConsent) return;
        if (getCookieValue('consentCookie') !== null) return;

        let cancelled = false;

        fetch('https://api.nanosite.pro/public/gdpr')
            .then(r => r.json())
            .then(data => {
                if (cancelled || getCookieValue('consentCookie') !== null) return;
                if (!data.show_gdpr) {
                    setCookie('consentCookie', 2, 365);
                } else {
                    setVisible(true);
                }
            })
            .catch(() => {
                if (cancelled || getCookieValue('consentCookie') !== null) return;
                setVisible(true);
            });

        return () => { cancelled = true; };
    }, []);

    if (!showCookieConsent || !visible) return null;

    const handleAccept = () => {
        setCookie('consentCookie', 1, 365);
        setVisible(false);
        window.dispatchEvent(new Event('cookieConsentAccepted'));
    };

    const handleDecline = () => {
        setCookie('consentCookie', 0, 7);
        setVisible(false);
    };

    return (
        <div className="cookie-bar">
            <p className="cookie-bar-text">
                This website uses cookies to improve your experience.
            </p>
            <div className="cookie-bar-actions">
                <button className="cookie-bar-btn cookie-bar-btn--decline" onClick={handleDecline}>
                    Decline
                </button>
                <button className="cookie-bar-btn" onClick={handleAccept}>
                    Accept
                </button>
            </div>
        </div>
    );
}

export default CookieConsent;
